import { type FunctionComponent, useContext } from "react";
import InfoBanner from "components/shared/InfoBanner";
import PageTitle from "components/shared/PageTitle";
import JobFinanceStatus from "components/job/JobLayout/JobFinanceStatus";
import JobStatus from "components/job/JobLayout/JobStatus";
import JobActions from "../JobActions";
import { useSelector } from "react-redux";
import jobSelectors from "store/selectors/job";
import { selectors } from "store";

const JobBanner: FunctionComponent = function () {
  const job = useSelector(jobSelectors.getEntity);
  const isLoading = useSelector(selectors.getIsLoading);

  return (
    <>
      <PageTitle>{job?.title}</PageTitle>
      <InfoBanner
        title={job?.title}
        isLoading={isLoading}
        nameContent={
          <>
            <div className="flex flex-row flex-wrap">
              <>
                <JobStatus />
                <JobFinanceStatus />
              </>
            </div>
            <JobActions />
          </>
        }
      />
    </>
  );
};

export default JobBanner;
